/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiGroupDescription } from '../models/ApiGroupDescription';
import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiGroupFull {
    'id': string;
    'name': string;
    'group': ApiGroupDescription;
    'created_at': number;
    'created_by': ApiProfileMin;
    'visible': boolean;
    'is_private': boolean;
    'is_direct_message'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "group",
            "baseName": "group",
            "type": "ApiGroupDescription",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "created_by",
            "baseName": "created_by",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "visible",
            "baseName": "visible",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "is_private",
            "baseName": "is_private",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "is_direct_message",
            "baseName": "is_direct_message",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiGroupFull.attributeTypeMap;
    }

    public constructor() {
    }
}

